"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var border = {
  radius: {
    0: '0',
    1: '3px',
    2: '6px',
    3: '24px'
  },
  width: {
    1: '1px',
    2: '2px',
    3: '3px'
  },
  style: {
    1: 'solid',
    2: 'dashed',
    3: 'dotted'
  }
};
var _default = border;
exports["default"] = _default;